import { Alert } from 'rsuite';
import { queryClient } from '../../../../../App';
import { AlertWithTimestamp } from '../../../../../components/AlertWithTimestamp';
import { Exception } from '../../../../../data';
import { api } from '../../../../../lib';
import { ChannelsConfigSchema } from '../../../../../reducers/reducerIPA/channels';

export function getSetupIpaChannelsQuery() {
  async function getSetupIpaChannels(): Promise<ChannelsConfigSchema> {
    const response = await api.get<ChannelsConfigSchema>('/setup/channels', { expectToken: true });
    return response.data;
  }

  return {
    queryKey: ['ipa/setup-form/channels'],
    queryFn: getSetupIpaChannels,
  };
}

export const mutateSetupIpaChannels = () => {
  async function patchSetupIpaChannels(data: ChannelsConfigSchema) {
    try {
      const response = await api.patch('/setup/channels', data, { expectToken: true });
      Alert.success('Configurações salvas com sucesso!');
      return response.data;
    } catch {
      const { message } = new Exception('Erro ao salvar configurações.');
      throw AlertWithTimestamp({ message });
    }
  }

  return {
    mutationFn: patchSetupIpaChannels,
    onSuccess: () => {
      queryClient.invalidateQueries(getSetupIpaChannelsQuery().queryKey);
    },
  };
};
